var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.707 17.792a1 1 0 1 0 1.414 1.414l5.657-5.656 5.657 5.656a1 1 0 0 0 1.414-1.414l-5.657-5.657L18.85 6.48a1 1 0 0 0-1.414-1.415l-5.657 5.657-5.657-5.657A1 1 0 1 0 4.707 6.48l5.657 5.656z",
    clipRule: "evenodd"
  })));
};
export default SvgClose;